import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import { SettingsProvider } from "./context/SettingsContext";
import Landing from "./pages/Landing";
import About from "./pages/About";
import AuthCallback from "./pages/AuthCallback";
import Dashboard from "./pages/Dashboard";
import Jobs from "./pages/Jobs";
import JobForm from "./pages/JobForm";
import JobDetail from "./pages/JobDetail";
import Resume from "./pages/Resume";
import SharedJob from "./pages/SharedJob";
import AccountDeleted from "./pages/AccountDeleted";
import Archive from "./pages/Archive";
import Metrics from "./pages/Metrics";
import SettingsPage from "./pages/Settings";
import Admin from "./pages/Admin";
import AppShell from "./components/AppShell";
import ProtectedRoute from "./components/ProtectedRoute";

function AppRouter() {
  const location = useLocation();
  // Process OAuth callback FIRST, synchronously, before any other routing
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/about" element={<About />} />
      <Route path="/share/:shareId" element={<SharedJob />} />
      <Route path="/goodbye" element={<AccountDeleted />} />
      <Route element={<ProtectedRoute><AppShell /></ProtectedRoute>}>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/jobs" element={<Jobs />} />
        <Route path="/jobs/new" element={<JobForm />} />
        <Route path="/jobs/:id" element={<JobDetail />} />
        <Route path="/jobs/:id/edit" element={<JobForm />} />
        <Route path="/metrics" element={<Metrics />} />
        <Route path="/archive" element={<Archive />} />
        <Route path="/resume" element={<Resume />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="/admin" element={<Admin />} />
      </Route>
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <SettingsProvider>
            <AppRouter />
            <Toaster position="top-center" theme="light" />
          </SettingsProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
